import styled from 'styled-components';

export const StyledFlex = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
  flex-direction: row;
  .btn-add-new {
    margin-left: auto;
  }
`;

export const StyledAgencyFilterButton = styled.button<{ active?: boolean }>`
  font-size: ${({ theme }) => theme.font.size.lg};
  color: ${({ theme }) => theme.palette.text.primary};
  background: ${({ theme }) => theme.palette.background.paper};
  border-radius: ${({ theme }) => theme.sizes.borderRadius.base};
  border: 1px solid
    ${({ theme, active }) =>
      active ? theme.palette.blue[500] : theme.palette.neutral[300]};
  padding: 9px 12px;
  cursor: pointer;

  display: flex;
  align-items: center;
`;
